module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/warriors.273157f.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/warriors.png
// module id = EVoz
// module chunks = 0